import React, { Component } from 'react';
import { common } from 'plato-js-client';

class Document extends Component {
  componentDidMount = () => {
    
    var document = new common.Document(this.props.match.params.id);
    document.get().then(() => {
      this.setState({ document: document });
      document.file.get().then(() => {
        this.setState({ document: document });
      }, error => this.setState({ error: error }));
    }, error => this.setState({ error: error }));
  }

  render() {
    if (this.state && this.state.error) {
      return this.state.error.toString();
    }

    if (!(this.state && this.state.document)) {
      return 'Loading…';
    }

    return (
      <React.Fragment>
        <h4>{ this.state.document.name }</h4>
        { this.state.document.file.url &&
          <React.Fragment>
            <p><a className='btn btn-secondary btn-sm' href={ this.state.document.file.url } download={ this.state.document.name }>Download invoice</a></p>
            {this.state.document.id && 
              <embed src={ this.state.document.file.url } width={ '800px' } height={ '1200px' } type={ this.state.document.mimetype.name } />
            }
          </React.Fragment>
        }
      </React.Fragment>
    );
  }
}

export default Document;



// WEBPACK FOOTER //
// ./src/Document.js